// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7c31e9c0","453":"ef7ca481","796":"77059040"}[chunkId] + ".chunk.js";
};